// Copyright ©️ 2026 eVolve MEP, LLC

import { Stack } from '@mantine/core';

import { MobileBasePageHeader } from 'components/Mantine/MobileBasePageHeader';
import type { ShipmentDetailPageProps } from 'modules/Shop/Shipments/ShipmentDetail/ShipmentDetailWrapper';

import { ShipmentSidePane } from '../ShipmentSidePane';

export const MobileShipmentDetailsView = ({ shipment, onShipmentUpdated }: ShipmentDetailPageProps) => (
  <Stack flex={1} mih={0} w="100%" p="md" pb={0} gap="xs">
    <MobileBasePageHeader
      title={shipment.identifier}
      parentPage={{ title: shipment.identifier, url: `/shipping-orders/${shipment.shipmentId}` }}
    />
    <Stack flex={1} style={{ overflowY: 'auto' }} gap="md">
      <ShipmentSidePane shipment={shipment} onShipmentUpdated={onShipmentUpdated} />
    </Stack>
  </Stack>
);
